import React, { useState, useEffect } from 'react'

import { Col, FlexboxGrid, Message, Panel, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanel from '../../ButtonPanel'
import ViewFormWidget from '../dynamicForm/ViewFormWidget'
import EditFormWidget from '../dynamicForm/EditFormWidget'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import HTMLWidget from '../../HTMLWidget'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { doneLoading, startLoading } from '../../../utils/loading'
import { saveFormOperatingPeriod } from '../../../redux/actions/subProjectProposal'
import { setAlertMessage } from '../../../utils/messageUtil'
import InputDateForm from '../../../components/forms/input/InputDateForm'
import CustomAlertMessage from '../../CustomAlertMessage'
import moment from 'moment'

export default function OperatingPeriodWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props

  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()

  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [notiMsg, setNotiMsg] = useState()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [startDate, setStartDate] = useState(
    formSchema.objects ? formSchema.objects[0]?.value : undefined
  )
  const [endDate, setEndDate] = useState(
    formSchema.objects ? formSchema.objects[1]?.value : undefined
  )

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveFormOperatingPeriod(subProjectId, request)
      if (response) {
        setFormSchema(response)
        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }
    } catch (e) {
      // console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let values = []

    formSchema.objects?.forEach((e) => {
      var value = data[e.name] || null

      // if(e.type == "DATE"){
      //   value =
      // }
      values.push({
        key: e.id,
        name: e.name,
        value: value,
        type: e.type,
      })
    })

    let request = {
      id: formSchema.id,
      values: values,
    }

    handleSave(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {/* <WarningMessage message={formSchema?.feedbackBySubject} /> */}

      {isEdit && showCommandButton ? (
        <>
          {formSchema.description && (
            <Row style={{ marginBottom: 10 }}>
              <CustomAlertMessage contents={formSchema.description} />
            </Row>
          )}
          <FlexboxGrid>
            {formSchema.objects && formSchema.objects[0] && (
              <FlexboxGrid.Item
                componentClass={Col}
                colspan={24}
                xs={24}
                sm={24}
                md={formSchema.objects[0].sizeMdLg || 24}
                lg={formSchema.objects[0].sizeMdLg || 24}
              >
                <InputDateForm
                  schema={formSchema.objects[0]}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  getValues={getValues}
                  clearErrors={clearErrors}
                  disabled={formSchema.disabled}
                  //startDate={startDate}
                  endDate={endDate}
                  //disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
                  onChange={(val) => {
                    console.log(val)

                    setStartDate(val)
                  }}
                />
              </FlexboxGrid.Item>
            )}
            {formSchema.objects && formSchema.objects[1] && (
              <FlexboxGrid.Item
                componentClass={Col}
                colspan={24}
                xs={24}
                sm={24}
                md={formSchema.objects[1].sizeMdLg || 24}
                lg={formSchema.objects[1].sizeMdLg || 24}
              >
                <InputDateForm
                  schema={formSchema.objects[1]}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  getValues={getValues}
                  clearErrors={clearErrors}
                  disabled={formSchema.disabled}
                  startDate={startDate}
                  //endDate={endDate}
                  //disabledDate={(date) => startDate && moment(startDate).isAfter(date, new Date())}
                  onChange={(val) => {
                    setEndDate(val)
                  }}
                />
              </FlexboxGrid.Item>
            )}
          </FlexboxGrid>
          {/* <EditFormWidget
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
          /> */}
        </>
      ) : (
        <ViewFormWidget schema={formSchema} />
      )}

      {formSchema.note && (
        <Message
          showIcon
          type="info"
          style={{ marginTop: 20 }}
          description={<HTMLWidget data={formSchema.note} />}
        />
      )}

      {showCommandButton && !mode && (
        <div className="right">
          <hr />
          {notiMsg && (
            <Message
              closable
              showIcon
              type={notiMsg.type}
              description={notiMsg.msg}
              onClose={() => setNotiMsg('')}
              style={{ marginBottom: 10 }}
              className="left"
            />
          )}

          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </div>
      )}
    </Panel>
  )
}
